export default __webpack_public_path__ + "static/media/note-white.ca5b7fe8.svg";